import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c495e34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contents" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-menu-3" }, null, -1))
const _hoisted_4 = { class: "tab-bar" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-xin" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-a-ziyuan11" }, null, -1))
const _hoisted_7 = { class: "list" }
const _hoisted_8 = ["onClick"]

import i18, { State as I18State } from '@/store/i18';
import contents from '@/views/assets/contents';
import { computed, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = useStore()

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].bible)

const current = computed(() => {
    if (route.name == 'bible-detail') {
        return parseInt(route.params.volume as string) - 1
    } else {
        return -1
    }
})
const state = reactive({
    news: false
})
function goDetail(i: number) {
    let volume = i
    let chapter = 0
    router.push({
        name: 'bible-detail',
        params: {
            volume: volume + 1,
            chapter: chapter + 1,
            lang: '0'
        }
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", null, _toDisplayString(_unref(lang).bible), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        class: _normalizeClass(["fold", { on: !_unref(state).news }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).news = false))
      }, [
        _hoisted_5,
        _createTextVNode(_toDisplayString(_unref(lang).old), 1)
      ], 2),
      _createElementVNode("a", {
        class: _normalizeClass(["fold", { on: _unref(state).news }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).news = true))
      }, [
        _hoisted_6,
        _createTextVNode(_toDisplayString(_unref(lang).new), 1)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contents), (item, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (_unref(state).news ? (i >= 39) : (i < 39))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: _normalizeClass(["navigator", { on: _unref(current) == i }]),
                onClick: ($event: any) => (goDetail(i))
              }, _toDisplayString(_unref(i18data).lang.list[_unref(i18data).lang.now] == 'zh-CN' ? item.name : item.english), 11, _hoisted_8))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ])
  ]))
}
}

})